import { Component, OnDestroy, OnInit } from '@angular/core';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoaderService } from '../../services/loader.service';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-loader',
    imports: [ProgressSpinnerModule],
    template: `
    @if (isLoading) {
      <div class="loader-overlay" role="alert" aria-busy="true" aria-live="assertive">
        <div class="loader-container">
          <p-progressSpinner
            strokeWidth="4"
            ariaLabel="Loading"
            [style]="{width: '50px', height: '50px'}"
            animationDuration=".5s">
          </p-progressSpinner>
          <span class="loader-text">Loading…</span>
        </div>
      </div>
    }
    `,
    styles: [`
    .loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.85);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      backdrop-filter: blur(4px);
    }

    .loader-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: var(--surface-card);
      padding: 2rem;
      border: 1px solid var(--surface-border);
      border-radius: var(--border-radius-lg);
      box-shadow: var(--shadow-md);
      animation: fadeIn 0.2s ease, slideUp 0.22s ease;
    }

    .loader-text {
      margin-top: 1rem;
      color: var(--text-color-secondary);
      font-size: 0.8125rem;
      font-weight: 550;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes slideUp {
      from { transform: translateY(10px); }
      to { transform: translateY(0); }
    }
  `]
})
export class LoaderComponent implements OnInit, OnDestroy {
    isLoading = false;
    private subscription = new Subscription();

    constructor(
        private loaderService: LoaderService,
        private router: Router
    ) { }

    ngOnInit() {
        // Subscribe to loader service
        this.subscription.add(
            this.loaderService.loading$.subscribe(
                loading => this.isLoading = loading
            )
        );

        // Subscribe to router events
        this.subscription.add(
            this.router.events.subscribe(event => {
                if (event instanceof NavigationStart) {
                    this.loaderService.show();
                }
                if (event instanceof NavigationEnd ||
                    event instanceof NavigationCancel ||
                    event instanceof NavigationError) {
                    this.loaderService.hide();
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}